import {useMutation, gql} from '@apollo/client'

const useIssueCheckInToStudent = (onSuccess = () => {}, onError = () => {}) => {
    return useMutation(
        gql`
            mutation(
                $studentId: String!
                $checkInId: String
                $reason: IssueCheckInReason!
                $serviceReason: String
            ) {
                issueCheckInToStudent (
                    studentId: $studentId
                    checkInId: $checkInId
                    reason: $reason
                    serviceReason: $serviceReason
                )
            }
        `,
        {
            onCompleted: onSuccess, onError
        }
    )
}

export default useIssueCheckInToStudent